import { MenuItem, Drawer, AppBar, List, ListItemButton, Box, Button, IconButton, Typography } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const MenuButton = styled(Button)`
  color: ${theme.palette.text.primary};
  margin: 8px;
  text-transform: none;
  text-align: left;
  justify-content: flex-start;
  transition: background-color 0.15s ease;
  &:hover {
    background-color: ${theme.palette.background.default};
  }
  &.bordered {
    border: 1px solid ${theme.palette.divider};
  }
`;

export const SideMenuDrawer = styled(Drawer)`
  &.full-width {
    > div {
      width: 100vw;
    }
  }
  > div {
    z-index: 1;
    position: fixed;
    top: 0;
    padding-top: calc(${theme.height.topMenu} - 10px);
    width: ${theme.width.sideMenu};
    border: none;
    background-color: ${theme.palette.primary.white};
    background-image: none;

    ul {
      padding-top: 0;

      a:first-child {
        margin-top: 0;
      }
    }
  }
`;

export const MenuList = styled(List)``;

export const ListMenuItem = styled(ListItemButton)`
  text-decoration: none;
  color: ${theme.palette.text.primary};
  font-size: ${theme.typography.fontSize}px;
  gap: 10px;
  margin: 9px 12px;
  justify-content: flex-start;
  border-radius: 8px;
  transition: background-color 0.15s ease;

  .pre {
    position: absolute;
    left: 0px;
    top: 6px;
    bottom: 6px;
    width: 3px;
    border-radius: 2px;
  }

  &.Mui-selected {
    background: none;
    background-color: ${theme.palette.menu.selected};

    & .MuiListItemText-primary {
      font-weight: 700 !important;
    }

    & .MuiTypography-root {
      font-weight: 700 !important;
    }

    &:hover {
      background-color: ${theme.palette.background.default};
    }

    .pre {
      background: ${theme.palette.menu.selectedSpan};
    }
  }
`;

export const StyledAppBar = styled(AppBar)`
  background-color: ${theme.palette.primary.white};
  background-image: none;
  box-shadow: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: ${theme.height.topMenu};
`;

export const TopMenuItem = styled(MenuItem)`
  text-decoration: none;
  color: ${theme.palette.primary.main};
`;

export const SideMenuGroupHeader = styled(Typography)`
  font-size: ${theme.typography.fontSizeSmall}px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${theme.palette.text.secondary};
  padding: 16px 24px 4px;
  display: block;
`;

export const SidebarToggleWrapper = styled(Box)`
`;

export const SidebarToggleButton = styled(IconButton)`
  border-radius: 0;
  color: ${theme.palette.text.primary};
`;
